import { addAccountsToGroupBulkActionType } from '../../../../../../../backend/features/accounts/shared';
import { showGroupsDialog } from '../../../../../../../ui/features/groups';
import { getFilterForBulkAction } from '../../../../../../../utils';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
export function handleAddToExistingGroup({ t, selectedRowIds, appliedStorageFilters, onDeselectAllRows }) {
    showGroupsDialog({
        excludeFilterBasedGroups: true,
        onSelect: (selectedGroupId) => {
            launchBulkAction({
                type: addAccountsToGroupBulkActionType,
                title: t('panels.groups.addingAccountsToGroup'),
                params: {
                    groupId: selectedGroupId,
                    filter: getFilterForBulkAction(selectedRowIds, appliedStorageFilters),
                },
                onClose: () => {
                    onDeselectAllRows === null || onDeselectAllRows === void 0 ? void 0 : onDeselectAllRows();
                },
            });
        },
    });
}
